import m from "../rule/index.mjs";
import { isEmptyValue as n } from "../util.mjs";
var h = function(r, i, t, e, f) {
  var d = [], o = r.required || !r.required && e.hasOwnProperty(r.field);
  if (o) {
    if (n(i) && !r.required)
      return t();
    m.required(r, i, e, d, f), i !== void 0 && m.type(r, i, e, d, f);
  }
  t(d);
};
export {
  h as default
};
//# sourceMappingURL=method.mjs.map
